import { create } from 'zustand';
import type { ImpersonationSession } from '@field-tickets/shared';

interface ImpersonationState {
  session: ImpersonationSession | null;
  setSession: (session: ImpersonationSession | null) => void;
}

export const useImpersonationStore = create<ImpersonationState>((set) => ({
  session: null,
  setSession: (session) => set({ session }),
}));
